import {
  getDoc,
  updateDoc,
  setDoc,
  Transaction
} from 'firebase/firestore';

import { BaseDao } from './base-dao';


import { Novel } from '@/lib/types';

/**
 * Data Access Object for the root Novel document.
 */
export class NovelDao extends BaseDao {
  /**
   * Fetches the root novel document for a user.
   */
  async getNovel(userId: string, novelId: string): Promise<Novel> {
    const ref = this.resolver.getNovelRef(userId, novelId);
    const snap = await getDoc(ref);

    if (!snap.exists()) {
      throw new Error(`Novel not found: ${novelId}`);
    }

    return { ...(snap.data() as Novel), id: snap.id };
  }

  /**
   * Updates fields on the root novel document.
   */
  async updateNovel(
    userId: string,
    novelId: string,
    updates: Partial<Novel>,
    transaction?: Transaction
  ): Promise<void> {
    const ref = this.resolver.getNovelRef(userId, novelId);
    if (transaction) {
      transaction.update(ref, updates as Record<string, unknown>);
    } else {
      await updateDoc(ref, updates as Record<string, unknown>);
    }
  }

  /**
   * Upserts the root novel document.
   */
  async setNovel(
    userId: string,
    novel: Novel,
    transaction?: Transaction
  ): Promise<void> {
    const ref = this.resolver.getNovelRef(userId, novel.id);
    if (transaction) {
      transaction.set(ref, novel, { merge: true });
    } else {
      await setDoc(ref, novel, { merge: true });
    }
  }
}
